import { FC } from 'react';
import { useToast } from '@rich-products-corp/react-ecomm-ui/dist';
import { useIncrementDecrement } from '@rich-products-corp/react-ecomm-ui/dist/components/atomic/atoms/IncrementDecrementSelector';
import { LinkButton } from '@rich-products-corp/react-ecomm-ui/dist/components/atomic/atoms/LinkButton';
import { Variant } from '@rich-products-corp/react-ecomm-ui/dist/types/product/Variant';
import { cn } from '@rich-products-corp/react-ecomm-ui/dist/utils/classNames';
import { UseCart } from '@/frontastic/provider/frontastic/UseCart';

interface PDPAddToCartProps {
  useCart: UseCart;
  singleVariant: Variant;
  store?: string;
  isOnStock?: boolean;
  onAddToCart?: (variant: Variant, quantity: number, store?: string) => void;
  extended?: {
    addToBagIcon?: JSX.Element;
    addToBagIconPosition?: 'left' | 'right';
  };
}

export const PDPAddToCart: FC<PDPAddToCartProps> = ({
  useCart,
  singleVariant,
  extended,
  store,
  isOnStock,
  onAddToCart,
}) => {
  const { IncrementDecrement, selectedQty } = useIncrementDecrement({
    disabled: !isOnStock,
  });
  const { toast } = useToast();

  async function addToCart() {
    if (isOnStock) {
      if (onAddToCart) onAddToCart(singleVariant, selectedQty, store);
      const addItem = await useCart.addItem(singleVariant, selectedQty, store);
      if (addItem?.error) {
        toast({
          title: 'Error adding item to cart',
          description:
            "We couldn't add the item to your cart. Please try again or contact support if the issue persists.",
        });
      }
    }
  }

  return (
    <div className="flex items-center sm:flex-row">
      <div className="mr-4">
        <IncrementDecrement />
      </div>

      <div onClick={addToCart} className="w-full">
        <LinkButton
          fullWidth
          className={cn(
            'add-to-cart-button',
            !isOnStock ? 'text-black hover:text-black pointer-events-none bg-[#d1d5db] bg-[#d1d5db]' : '',
          )}
        >
          <div className="flex w-full items-center justify-center space-x-2">
            {extended?.addToBagIconPosition === 'left' && extended.addToBagIcon}
            <div>{!isOnStock ? 'SOLD OUT' : 'Add to Cart'}</div>
            {extended?.addToBagIconPosition === 'right' && extended.addToBagIcon}
          </div>
        </LinkButton>
      </div>
    </div>
  );
};
